import { Size } from '../rocket';

export interface DomImagePromiseResolveValue {
  image: HTMLImageElement;
  source: string;
}

export class DOMImage {
  public static load(source: string): Promise<DomImagePromiseResolveValue> {
    return new Promise((resolve, reject) => {
      const image = new Image();

      image.addEventListener('load', () => {
        resolve({ image, source });
      });

      image.addEventListener('error', () => {
        reject(new Error('DOMImage.load: There is an error loading image.'));
      });

      image.src = source;
    });
  }

  public static getSize(source: string): Promise<Size> {
    return new Promise((resolve, reject) => {
      const image = new Image();

      image.addEventListener('error', () => {
        reject(new Error('DOMImage.getSize: There is an error loading image.'));
      });

      image.src = source;

      const intervalId = setInterval(() => {
        if (
          typeof image.naturalWidth === 'number'
          && typeof image.naturalHeight === 'number'
        ) {
          clearInterval(intervalId);

          resolve({
            width: image.naturalWidth,
            height: image.naturalHeight,
          });
        }
      }, 10);
    });
  }
}
